import type { paths } from "../openapi/schema";

type PatientMedicationPatchBody = NonNullable<
  paths["/{tenantId}/patients/{patientId}/medications/{medicationId}"]["patch"]["requestBody"]
>["content"]["application/json"];

/** Canonical delivery-form values accepted by Dashboard API. */
export type PatientMedicationForm = NonNullable<
  PatientMedicationPatchBody["form"]
>;

export const PATIENT_MEDICATION_FORMS = [
  "tablet",
  "capsule",
  "injection_solution",
  "lyophilized_powder",
  "pre_filled_pen",
  "pre_filled_syringe",
  "vaginal_gel",
  "vaginal_suppository",
  "transdermal_patch",
  "nasal_spray",
  "cream",
  "oral_solution",
  "sublingual_tablet",
  "other",
] as const satisfies readonly PatientMedicationForm[];

const PATIENT_MEDICATION_FORM_SET = new Set<string>(PATIENT_MEDICATION_FORMS);

const SOURCE_TO_API_FORM: Record<string, PatientMedicationForm> = {
  pen: "pre_filled_pen",
  stylo: "pre_filled_pen",
  syringe: "pre_filled_syringe",
  seringue: "pre_filled_syringe",
  tablets: "tablet",
  capsules: "capsule",
  patch: "transdermal_patch",
};

/**
 * Convert an OCR/editor delivery-method string to the canonical API enum.
 * Empty and unrecognized values serialize as null so an arbitrary extracted
 * string can never reach the API (mirrors serializeMedicationRoute).
 */
export function serializeMedicationForm(
  value: string | null | undefined,
): PatientMedicationForm | null {
  const normalized = value?.trim().toLowerCase().replace(/[\s-]+/g, "_");
  if (!normalized) return null;

  const apiValue = SOURCE_TO_API_FORM[normalized] ?? normalized;
  return PATIENT_MEDICATION_FORM_SET.has(apiValue)
    ? (apiValue as PatientMedicationForm)
    : null;
}
